import moment from 'moment';
import React from 'react';
import {MealTypes as _MealTypes, MenuOrderTypes} from '../../../../../server/constants'
function MenuCalender(props) {
    const MealTypes={
        breakfast:'BREAKFAST',
        meal:'MEAL',
        side:'SIDE',
        holiday:'HOLIDAY'
    };
    let {orderedMenu} = props;
    let year = moment(props.date).format('YYYY');
    let month = moment(props.date).format('MM');
    let firstDay = moment([ parseInt(year), parseInt(month)-1]).day();
    let daysInMonth = parseInt(moment([ parseInt(year), parseInt(month)-1]).endOf('month').format('DD'));
    let date=1;
   return (
      <table className="table table-bordered table-responsive" id="calendar">
            <thead >
              <tr className="bg-color-1 tblHead">
              {
                  [0,1,2,3,4,5,6].map(i=>{
                      return (props.hiddenDays||[]).includes(i)?
                      <th className="col-lg-2" style={{display:'none'}}>{moment().day(i).format('ddd')}</th>:
                      <th className="col-lg-2">{moment().day(i).format('ddd')}</th>
                  })
              } 
              </tr>
            </thead>
            <tbody>
              {
                [0,1,2,3,4,5].map((i)=>{
                 return(  <tr>{
                  [0,1,2,3,4,5, 6].map((j)=>{                                       
                    if(i===0 && j<firstDay){                        
                        return (props.hiddenDays||[]).includes(j)?<td style={{display:'none'}}></td>: <td className="tblBodyCol">{}</td>
                      }else if(date > daysInMonth){
                      return null                      
                    }else{
                      let _todayMealList=[];
                      _todayMealList=  orderedMenu.filter(item=>{
                       return moment(item.start).format('YYYY-MM-DD')===moment(new Date(parseInt(year),(parseInt(month)-1),date)).format('YYYY-MM-DD');
                      })
                      let _str=(props.hiddenDays||[]).includes(j)?<td style={{display:'none'}}></td>:
                      <td className="tblBodyCol" data-date={moment(new Date(parseInt(year),(parseInt(month)-1),date)).format('YYYY-MM-DD')}>
                        <span className="tblBodyColDate">{date}</span>
                        {
                          _todayMealList.length>0?
                          _todayMealList.sort((a, b) => a.title.localeCompare(b.title)).map((fItem)=>{
                         return (fItem.type===MealTypes.meal || fItem.type===MealTypes.breakfast ||  fItem.type==MenuOrderTypes.ITEMIZE.toUpperCase() || fItem.type ===_MealTypes.snack.toUpperCase())?
                         <div className="title label-success" style={{backgroundColor:'rgb(11, 86, 103)'}}>
                        {fItem.title +': '+(fItem.count||0)}
                        </div>:
                        fItem.type===MealTypes.side?
                        <div className="title label-info" style={{backgroundColor:"rgba(122, 136, 121, 0.97)"}}><span>{fItem.title}</span>
                        </div>:<div><span>{fItem.title}</span></div>
                        }):null
                        }
                      </td>
                      date++;
                      return _str;
                    }
                  })}
                  </tr>);
                })
              }
            </tbody>
     </table>
   )

}

export default MenuCalender;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/AdminReports/menuCalender/menuCalender.jsx